import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Banner } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

const StyledBanner = styled(Banner)`
    padding: 12px;
    border-radius: 3px;
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
    background-color: ${colorsPalettes.bluegrey[200]};
`;

interface ILobWarningBannerProps {
    excludedSites: string[];
}
const LobWarningBanner: FC<ILobWarningBannerProps> = ({ excludedSites }) => {
    const excludedSitesStr = excludedSites.join(", ");

    return (
        <StyledBanner
            title={
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon[400]}
                >
                    {translate("analysis.content.lob.warning.banner.title")} <b>{excludedSitesStr}</b>
                </Text>
            }
            CustomIcon={
                <SWReactIcons
                    iconName="warning"
                    size="sm"
                />
            }
        />
    );
};

export default LobWarningBanner;
